import React, { Component, Fragment } from "react";
import Loader from "../Components/Loading";
import BackendClient from "../BackendClient";

export default class Services extends Component {
  state = {
    isFetched: false,
    isFetching: false,
    items: null
  };

  componentWillUnmount() {
    this.isCancelled = true;
  }

  componentDidMount = () => {
    const { isFetched, isFetching } = this.state;
    if (!(isFetched && isFetching)) {
      !this.isCancelled &&
        this.setState({ isFetched: false, isFetching: true });
      !this.isCancelled &&
        BackendClient.getCarousels({
          expand: "items",
          "filter[key]": "services"
        })
          .fetchJson()
          .then(([data]) => {
            const { items } = data || {};
            !this.isCancelled &&
              this.setState({
                items: items || null,
                isFetched: true,
                isFetching: false
              });
          });
    }
  };

  render() {
    const { isFetched, isFetching, items } = this.state;
    let content;

    if (!isFetched && isFetching) {
      content = <Loader loading />;
    } else {
      content = (
        <ul className="office-services services-list">
          {(items || []).map((element, index) => (
            <li key={index}>
              <a href={element.link}>
                <img src={element.url} alt={element.caption} />
                <span
                  className="list-title"
                  dangerouslySetInnerHTML={{ __html: element.caption }}
                />
              </a>
            </li>
          ))}
        </ul>
      );
    }
    return (
      <Fragment>
        <h1 className="office-h1">Услуги</h1>
        {content}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Services.jsx